import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { H3 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import Carousel from 'marketplace-ui-common/components/Carousel';
import * as FilterKey from '../../constants/search/FilterKey'; // @ts-expect-error module is untyped

import { getPathFromSearchKey } from '../../utils/params'; // @ts-expect-error module is untyped

import { push } from '../../utils/history'; // @ts-expect-error module is untyped

import { isProd } from '../../utils/env';
import { getServices } from '../../slices/serviceCatalogSlice';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { CAROUSEL_SERVICES_PROD, CAROUSEL_SERVICES_QA } from '../../constants/HomepageIconMap';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
const StyledServiceItemWrapper = styled.div.withConfig({
  displayName: "HomepageServicesCarousel__StyledServiceItemWrapper",
  componentId: "uazrk9-0"
})(["&&{max-width:none;width:auto;white-space:nowrap;display:flex;flex-direction:column;align-items:center;}"]);

const ServiceCarouselItem = ({
  name,
  iconName,
  onClick,
  to,
  isMobile
}) => /*#__PURE__*/_jsx(UIRouterLink, {
  className: isMobile ? 'm-all-4' : "",
  onClick: onClick,
  to: to,
  use: "unstyled",
  children: /*#__PURE__*/_jsxs(StyledServiceItemWrapper, {
    className: "m-bottom-4",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      className: "m-all-0 p-bottom-4",
      size: "medium",
      color: OBSIDIAN,
      name: iconName
    }), /*#__PURE__*/_jsx("div", {
      children: name
    })]
  })
});

export default function HomepageServicesCarousel({
  isMobile
}) {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const catalogServices = useSelector(getServices);
  const {
    cardsPerPage
  } = useResponsiveProps({
    cardsPerPage: {
      xl: 6,
      lg: 5,
      md: 3,
      sm: 2,
      xs: 1
    }
  });
  const renderedServiceButtons = useMemo(() => {
    const serviceIconMap = isProd() ? CAROUSEL_SERVICES_PROD : CAROUSEL_SERVICES_QA;
    return serviceIconMap.map(serviceIconObject => {
      const catalogService = catalogServices.filter(catService => catService.id === serviceIconObject.id)[0];
      return catalogService ? /*#__PURE__*/_jsx(ServiceCarouselItem, {
        onClick: () => {
          trackInteraction('click homepage service carousel', {
            feature: FilterKey.SERVICE,
            item_type: catalogService.id
          });
        },
        to: `/${getPathFromSearchKey(FilterKey.SERVICE, catalogService.id, catalogServices)}`,
        name: catalogService.name,
        iconName: serviceIconObject.iconName,
        isMobile: isMobile
      }, `carousel-service-${serviceIconObject.id}`) : null;
    });
  }, [catalogServices, isMobile, trackInteraction]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "services-carousel",
    className: "p-bottom-8",
    children: [isMobile && /*#__PURE__*/_jsx(UIButton, {
      className: "p-bottom-4",
      use: "link",
      onClick: () => push('/all'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.storefront.header.browseAll"
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      justify: "between",
      children: [/*#__PURE__*/_jsx(H3, {
        className: "p-bottom-6",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.servicesCarouselTitle"
        })
      }), !isMobile && /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        onClick: () => push('/all'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.seeAll"
        })
      })]
    }), isMobile ? /*#__PURE__*/_jsx(UIScrollContainer, {
      children: /*#__PURE__*/_jsx(UIFlex, {
        align: "stretch",
        direction: "row",
        children: renderedServiceButtons
      })
    }) : /*#__PURE__*/_jsx(Carousel, {
      maxCardsPerPage: cardsPerPage,
      showPagination: false,
      cards: renderedServiceButtons,
      gutterSize: 40
    })]
  });
}